// Filters
// --------------------------------------------------------
import api from '@/lib/api'
import {orderBy} from 'lodash'
import {getSorter} from '@/lib/sortOptions'

const state = {
  favorites: false,
  status: [],
  orderBy: 'activity'
}

const getters = {
  data: (state, getters, rootState, rootGetters) => {
    let premises = rootGetters['premises/premises']
    if (!premises) return []
    if (state.favorites) {
      premises = premises.filter(premise => premise.currentUser.favorited)
    }
    if (state.status.length > 0) {
      premises = premises.filter(premise => {
        return state.status.includes(premise.status)
      })
    }
    // Sort
    const sorter = getSorter(state.orderBy)
    return orderBy(premises, sorter.field, sorter.order)
  },
  favorites: state => state.favorites,
  orderBy: state => state.orderBy,
  selectedStatus: state => state.status
}

const mutations = {
  reset(state) {
    state.favorites = false
    state.status = []
    state.orderBy = 'activity'
  },
  favorites(state, selected) {
    state.favorites = !!selected
  },
  status(state, status) {
    if (!status) return
    const statuses = Array.isArray(status) ? status : [status]
    statuses.forEach(status => {
      const index = state.status.findIndex(_status => _status === status)
      index === -1 ? state.status.push(status) : state.status.splice(index, 1)
    })
  },
  orderBy(state, criteria) {
    state.orderBy = criteria || state.orderBy
  }
}

const actions = {
  setPreferences({commit}, preferences) {
    commit('favorites', preferences.premisesFavorite)
    commit('orderBy', preferences.premisesOrderBy)
    commit('status', preferences.premisesStatusFilter)
  },
  setOrderBy({commit}, {value, landscapeId}) {
    commit('orderBy', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      premisesOrderBy: value
    })
  },
  setFavorite({commit}, {value, landscapeId}) {
    commit('favorites', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      premisesFavorite: !!value
    })
  },
  setStatus({commit, getters}, {value, landscapeId}) {
    commit('status', value)
    return api.call('patch', `/landscapes/${landscapeId}/preferences`, {
      premisesStatusFilter: getters.selectedStatus
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
